"use client";

import { memo, useEffect } from "react";

import Loading from "@components/common/Loading";

const LoginRedirect = () => {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return <Loading />;
};

export default memo(LoginRedirect);
